var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"splash-screen"},[_c('div',{staticClass:"splash-content"},[_c('img',{staticClass:"splash-logo",attrs:{"src":_vm.BP_LOGO,"alt":"Logo"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }